import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgFood = function SvgFood(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0h35v35H0V0Zm22.101 7.462a.92.92 0 0 1 .92.92v6.266l.858-.528a.701.701 0 0 0 .346-.613V8.495a.92.92 0 0 1 1.84 0v5.012c0 .902-.465 1.724-1.234 2.188l-1.81 1.115v9.808a.92.92 0 1 1-1.84 0V16.81l-1.81-1.115a2.542 2.542 0 0 1-1.234-2.188V8.495a.92.92 0 1 1 1.84 0v5.012c0 .258.128.482.346.613l.01.006.848.522V8.382a.92.92 0 0 1 .92-.92Zm-10.988 1.95c.78-1.047 2.022-1.908 3.817-1.908a.92.92 0 0 1 .92.92V26.619a.92.92 0 0 1-1.84 0v-7.08h-2.336c-.961 0-1.742-.78-1.742-1.74V12.53c0-.032.002-.064.005-.095.084-.815.42-2.009 1.176-3.023Z",
      fill: "currentColor"
    }))
  }));
};
export default SvgFood;